// Module
var code = `<form name="form" class="report-filters filters">
  <div ng-repeat="filter in \$ctrl.effectiveFilterDefinition track by \$ctrl.trackByFilter(filter)"
       ng-if="\$ctrl.shouldRenderOnMissingContext(filter)"
         class="filter-element">

      <!-- SINGLE_CHOICE_LIST -->
      <div class="labelled-field filter" ng-if="filter.type == 'SINGLE_CHOICE_LIST'">
        <label class="add-on">{{filter.name}}</label>
        <select ng-model="\$ctrl.params[filter.code]"
                ng-options="entry.id as entry.code for entry in filter.context"
                ng-change="\$ctrl.onFilterChange()"
                class="filter-value {{ 'filter-code-' + filter.code }}">
        </select>
      </div>

      <!-- MULTIPLE_CHOICE_LIST -->
      <div class="labelled-field filter" ng-if="filter.type == 'MULTIPLE_CHOICE_LIST'">
        <label class="add-on">{{filter.name}}</label>

        <branch-filter
          ng-if="filter.dataType === 'BRANCH_TREE'"
          ng-model="\$ctrl.params[filter.code]"
          options="filter.context"
          ng-change="\$ctrl.onFilterChange()"
          class="filter-value {{ 'filter-code-' + filter.code }}"
          ng-required="true"
          ng-model-options="{ allowInvalid: true }"
        >
        </branch-filter>

        <loan-category-filter
          ng-if="filter.dataType === 'LOAN_CATEGORY_TREE'"
          ng-model="\$ctrl.params[filter.code]"
          options="filter.context"
          ng-change="\$ctrl.onFilterChange()"
          class="filter-value {{ 'filter-code-' + filter.code }}"
          ng-required="true"
          ng-model-options="{ allowInvalid: true }"
        >
        </loan-category-filter>

        <!--
             angularjs if we don't configure allowInvalid will propagate undefined value to this element
             which will then trigger setting default value
            --->
        <multiselect
            ng-if="filter.dataType === 'FLAT_COLLECTION'"
            ng-required="\$ctrl.getFilter(filter.code).required"
            items="filter.context"
            ng-model="\$ctrl.params[filter.code]"
            label-property="'code'"
            value-property="'id'"
            ng-change="\$ctrl.onFilterChange()"
            class="filter-value {{ 'filter-code-' + filter.code }}"
            ng-model-options="{ allowInvalid: true }"
            select-all-option="true">
        </multiselect>
      </div>

      <!-- STRING_PARAMETER -->
      <div class="labelled-field filter" ng-if="filter.type == 'STRING_PARAMETER'">
        <label class="add-on">{{filter.name}}</label>
        <input type="text"
               ng-model="\$ctrl.params[filter.code]"
               class="filter-value {{ 'filter-code-' + filter.code }}">
      </div>

      <!-- DAY -->
      <div class="labelled-field filter day" ng-if="filter.type == 'DAY'">
        <label class="add-on">{{filter.name}}</label>
        <date ng-required="true"
          class="filter-value {{ 'filter-code-' + filter.code }}"
          ng-model="\$ctrl.params[filter.code]"></date>
      </div>

      <!-- MONTH -->
      <div class="labelled-field filter" ng-if="filter.type == 'MONTH'">
        <label class="add-on">{{filter.name}}</label>
        <input type="month"
               ng-required="true"
               ng-model="\$ctrl.month"
               class="filter-value {{ 'filter-code-' + filter.code }}"
               ng-change="\$ctrl.formatMonthDate(filter.code)">
      </div>

      <!-- QUARTER -->
      <div class="labelled-field filter" ng-if="filter.type == 'QUARTER'">
        <label class="add-on">{{filter.name}}</label>
        <input type="month"
               ng-required="true"
               ng-model="\$ctrl.month"
               class="quarter filter-value {{ 'filter-code-' + filter.code }}"
               ng-change="\$ctrl.formatMonthDate(filter.code)"
               step="3">
      </div>

      <!-- YEAR -->
      <div class="labelled-field filter" ng-if="filter.type == 'YEAR'">
        <label class="add-on">{{filter.name}}</label>
        <select ng-model="\$ctrl.params[filter.code]"
                ng-required="true"
                ng-options="y as y for y in \$ctrl.years"
                class="filter-value {{ 'filter-code-' + filter.code }}">
        </select>
      </div>

      <!-- DATE_RANGE -->
      <div class="filter" ng-if="filter.type == 'DATE_RANGE'">
        <date-range-picker
            model="\$ctrl.params[filter.code]"
            class="filter-value {{ 'filter-code-' + filter.code }}">
        </date-range-picker>
      </div>
    </div>

    <!-- Actions -->
    <button ng-if="\$ctrl.config.buttons.filter.isVisible"
            class="btn btn-primary btn--filter"
            type="button"
            ng-disabled="\$ctrl.config.buttons.filter.isDisabled || form.\$invalid"
            ng-click="\$ctrl.config.buttons.filter.action()">
      {{\$ctrl.config.buttons.filter.text}}
    </button>
    <button ng-if="\$ctrl.config.buttons.download.isVisible"
            class="btn btn-success"
            type="button"
            ng-disabled="\$ctrl.config.buttons.download.isDisabled || form.\$invalid"
            ng-click="\$ctrl.config.buttons.download.action()">
      {{\$ctrl.config.buttons.download.text}}
    </button>
    <button ng-if="\$ctrl.config.buttons.downloadCsv.isVisible"
            class="btn btn-success"
            type="button"
            ng-disabled="\$ctrl.config.buttons.downloadCsv.isDisabled || form.\$invalid"
            ng-click="\$ctrl.config.buttons.downloadCsv.action()">
      {{\$ctrl.config.buttons.downloadCsv.text}}
    </button>
    <button ng-if="\$ctrl.config.buttons.downloadCustomFile.isVisible"
            class="btn btn-success"
            type="button"
            ng-disabled="\$ctrl.config.buttons.downloadCustomFile.isDisabled || form.\$invalid"
            ng-click="\$ctrl.config.buttons.downloadCustomFile.action()">
      {{\$ctrl.config.buttons.downloadCustomFile.text}}
    </button>
    <button ng-if="\$ctrl.config.buttons.downloadAsyncCustomFile.isVisible"
            class="btn btn-success"
            type="button"
            ng-disabled="\$ctrl.config.buttons.downloadAsyncCustomFile.isDisabled || form.\$invalid"
            ng-click="\$ctrl.config.buttons.downloadAsyncCustomFile.action()">
      {{\$ctrl.config.buttons.downloadAsyncCustomFile.text}}
    </button>
    <button ng-if="\$ctrl.config.buttons.print.isVisible"
            class="btn btn-success"
            type="button"
            ng-disabled="\$ctrl.config.buttons.print.isDisabled || form.\$invalid"
            ng-click="\$ctrl.config.buttons.print.action()">
      {{\$ctrl.config.buttons.print.text}}
    </button>
    <button ng-class="{'filter-element': print.isVisible}" ng-repeat="print in \$ctrl.config.buttons.reportPrints"
            class="btn btn-primary"
            type="button"
            ng-if="print.isVisible"
            ng-disabled="print.isDisabled || form.\$invalid"
            ng-click="print.action()">
      {{ print.text | translate:'REPORT' }}
    </button>
</form>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/common/filters/report-filters.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;